/**
 * @fileoverview GET handler for the "/apps/user_info/delete_users_running" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { appsUserInfoDeleteUsersRunning } from "./constants";
import type { AppsUserInfoDeleteUsersRunningResult } from "./types";
import { isAppsUserInfoDeleteUsersRunningResult } from "./validators";

export const getAppsUserInfoDeleteUsersRunning = reactQueryFetcherAdapter(
  appsUserInfoDeleteUsersRunning,
  (signal: AbortSignal): Promise<AppsUserInfoDeleteUsersRunningResult> => {
    return fetch("/apps/user_info/delete_users_running", "GET", {}, { signal });
  },
  isAppsUserInfoDeleteUsersRunningResult
);
